export const TODAY_ISOSTRING = new Date().toISOString()

export const STRICT_CLIENT_AREA_SELECTION_START = '2026-12-01'

export const isStrictClientAreaSelectionEnabled = () => {
  const today = new Date().toISOString().slice(0, 10)
  return today >= STRICT_CLIENT_AREA_SELECTION_START
}
